export const TableCol = () => {

    return [
        {
            title: 'Form No',
            dataIndex: 'form_no',
            key: 'form_no',
        },
        {
            title: 'Form Name',
            dataIndex: 'form_name',
            key: 'form_name',
        }
    ]
}